import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ServiceLaneFacade } from '@quorum/service-lane-root/facade';

@Component({
  selector: 'svc-gm-dashboard',
  templateUrl: './gm-dashboard.component.html',
  styleUrls: ['./gm-dashboard.component.scss'],
})
export class GmDashboardComponent implements OnInit, OnChanges {
  alertsUi: any = { collapsed: false };
  onStarUi: any = { collapsed: true };
  claimsHistoryUi: any = { collapsed: true };
  serviceContractWarrantiesUi: any = { collapsed: true };
  roHistoryUi: any = { collapsed: true };
  @Input() collapsed: boolean;
  constructor(
    public serviceLaneFacade: ServiceLaneFacade
  ) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.collapsed) {
      if (changes.collapsed.currentValue) {
        this.alertsUi.collapsed = changes.collapsed.firstChange ? false : true;
        this.onStarUi.collapsed = true;
        this.claimsHistoryUi.collapsed = true;
        this.serviceContractWarrantiesUi.collapsed = true;
        this.roHistoryUi.collapsed = true;
      } else {
        this.alertsUi.collapsed = false;
        this.onStarUi.collapsed = false;
        this.claimsHistoryUi.collapsed = false;
        this.serviceContractWarrantiesUi.collapsed = false;
        this.roHistoryUi.collapsed = false;
      }
    }
  }

  toggleCollapse(groupUiObject: any) {
    groupUiObject.collapsed = !groupUiObject.collapsed;
  }

  getOwnerCenterStatus(ownerCenterStatus: string) {
    let status: any = {};
    switch (ownerCenterStatus) {
      case 'NOT_FOUND':
        status = {
          class: 'danger',
          icon: 'warning',
          description: 'Owner Center account not found. Insufficient customer information',
        };
        break;
      case 'MISSING_INFO':
        status = {
          class: 'danger',
          icon: 'warning',
          description: 'Insufficient customer information',
        };
        break;
      case 'NOT_SUPPORTED':
        status = {
          class: 'danger',
          icon: 'warning',
          description: 'Owner Center account status cannot be determined',
        };
        break;
      case 'UNKNOWN':
        status = {
          class: 'danger',
          icon: 'warning',
          description: 'Owner Center account status is unknown',
        };
        break;

      case 'OWNER_CENTER':
      case 'ONSTAR_AND_OWNERCENTER':
        status = {
          class: 'pass',
          icon: 'done',
          description: 'Customer has an Owner Center account',
        };
        break;

      default:
        status = {
          class: 'warning',
          icon: 'warning',
          description: 'Unknown Owner Center account status',
        };
    }
    return status;
  }
}
